export function SET_USER_DATA({ commit }, [address, birthday, email, full_name]) {
    commit('SAVE_USER_DATA', [address, birthday, email, full_name])
}